import { isDate, parseISO } from 'date-fns';

import { isNilOrEmpty } from './is-nil-or-empty';

/** Given a date string formatted as YYYY-MM-DD will return a date object or null */
export function asDateOrNull(date: string | Date): Date {
  if (isDate(date)) {
    return date as Date;
  }

  if (!isNilOrEmpty(date)) {
    return parseISO(date as string);
  } else {
    return null;
  }
}
